import styles from './tableCell.module.css';

import classNames from 'classnames';
import { useTableContext } from '../TableProvider';
import UserFieldsRenderer from '../../../components/UserFieldsRenderer/index';

const TableCell = ({ type, cell }) => {
  const commonProps = {
    item: cell,
  };

  const {
    styleConfig: { defaultCell },
  } = useTableContext();
  return (
    <td className={classNames(styles.cell, defaultCell)}>
      <UserFieldsRenderer type={type} {...commonProps} forTable />
    </td>
  );
};

export default TableCell;
